import { capitalize } from '@vue/shared'

// typed lower case
export const lowerCase = <T extends string>(str: T) => (str.toLowerCase() as Lowercase<T>)

export { capitalize }

export function parseList<T>(list: string | T[]): T[] {
  if (typeof list === 'string')
    return list.split(',').map(i => i.trim()) as T[]

  return list
}

type DeepObject<T> = { [K in keyof T]: T[K] extends object ? DeepObject<T[K]> : T[K] }

export function trimObjectValues<T extends Record<string, unknown>>(obj: T): DeepObject<T> {
  const result = {} as DeepObject<T>

  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'string') {
      result[key as keyof T] = value.trim() as DeepObject<T>[keyof T]
    }
    else if (value && typeof value === 'object') {
      result[key as keyof T] = trimObjectValues(value as Record<string, unknown>) as DeepObject<T>[keyof T]
    }
    else {
      result[key as keyof T] = value as DeepObject<T>[keyof T]
    }
  }

  return result
}
